import {TenantAdminTab} from './TenantAdminConstants';

export enum TenantAdminActionType {
  TENANT_ADMIN_CHANGE_ACTIVE_TAB = 'TENANT_ADMIN_CHANGE_ACTIVE_TAB',
}

export interface TenantAdminActiveTabChangeAction {
  type: TenantAdminActionType.TENANT_ADMIN_CHANGE_ACTIVE_TAB;
  tab: TenantAdminTab;
}

export function changeActiveTab(tab: TenantAdminTab): TenantAdminActiveTabChangeAction {
  return {
    type: TenantAdminActionType.TENANT_ADMIN_CHANGE_ACTIVE_TAB,
    tab,
  };
}

export type TenantAdminAction = TenantAdminActiveTabChangeAction;
